import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { MeetingRoomData, MeetingRoomError } from "./element/OtherDetail";
import { validateObject } from "../../../utils/app.utils";
import moment from "moment";
import { BOOKING_MEETING_APPROVE, BOOKING_MEETING_ROOM } from "./enum";
import { booking_meeting_room_type_data, BookingMeetingRoomApi } from "../../../api/booking-meeting-room/booking-meeting-room.api";
import { routeName } from "../../../routes/routeName";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { BookingMeetingRoomFront } from "../../../api/booking-meeting-room-front/booking_meeting_room_front.api";
import { saveAs } from "file-saver";
import { BookingMeetingRoomApproveApi } from "../../../api/booking-meeting-room-approve/booking-meeting-room-approve.api";
import { PaymentChannelApi } from "../../../api/payment-channel/payment-channel.api";
import { bankListArray } from "../../cms/course-online/manage-payment-channel/enum/manage_payment";



type Props = {
    is_personal?: boolean;
}
export const useManageStateDetail = ({ is_personal }: Props) => {
    const { id } = useParams();
    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [room_meeting_type, set_room_meeting_type] = useState<{ label: string, value: string } | null>(null);
    const [step, set_step] = useState<number>(0);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [payment_channel_data, set_payment_channel_data] = useState<any>(null);
    const [select_bank, set_select_bank] = useState<any>(null);
    const [payment_file, set_payment_file] = useState<File | null>(null);
    const [is_outside, set_is_outside] = useState<boolean>(false);
    const [remark, set_remark] = useState<string>("");


    const [formState, setFormState] = useState<MeetingRoomData>({
        meeting_room_desc: "",
        meeting_room_end_date: "",
        meeting_room_end_time: "",
        meeting_room_name: "",
        meeting_room_start_date: "",
        meeting_room_start_time: "",
        meeting_room_status: BOOKING_MEETING_ROOM.WAITING_TO_CONSIDER,
        meeting_room_type: "",
        id_meeting_file_other: null,
        id_meeting_type: null,
        id_room_meeting: null,
        id_content: null,
        file: null
    })
    const [error_message, set_error_message] = useState<Partial<MeetingRoomError>>({});

    const clearErrorMessage = () => set_error_message({});

    const generateBody = async (is_draft?: boolean, status?: string): Promise<booking_meeting_room_type_data> => {
        let id_meeting_file_other: number | null = null;
        if (formState.file && !formState?.file?.id_meeting_room_file) {
            id_meeting_file_other = await uploadFileBookingMeeting(formState.file[0])
        } else {
            if (formState?.file?.id_meeting_room_file) {
                id_meeting_file_other = formState?.file?.id_meeting_room_file
            }
        }
        return {
            meeting_room_name: formState.meeting_room_name,
            meeting_room_start_date: formState.meeting_room_start_date ? moment(formState.meeting_room_start_date).format("YYYY-MM-DD") : null,
            meeting_room_end_date: formState.meeting_room_end_date ? moment(formState.meeting_room_end_date).format("YYYY-MM-DD") : null,
            meeting_room_start_time: formState.meeting_room_start_time,
            meeting_room_end_time: formState.meeting_room_end_time,
            meeting_room_desc: formState.meeting_room_desc,
            meeting_room_status: status ? status : is_draft ? BOOKING_MEETING_ROOM.DRAFT : formState.meeting_room_status,
            meeting_room_type: "BOOKING_MEETING_ROOM",
            id_room_meeting: selectedId,
            id_meeting_file_other: id_meeting_file_other
        }
    }
    const check_error_field = validateObject<MeetingRoomData>(formState, {
        exclude: ['id_meeting_type', 'id_content', 'id_room_meeting', 'meeting_room_desc', 'id_meeting_file_other', 'meeting_room_type'],
        customMessage: {
            meeting_room_start_date: 'ระบุวันที่เริ่มต้น',
            meeting_room_end_date: 'ระบุวันที่สิ้นสุด',
            meeting_room_start_time: 'ระบุเวลาเริ่มต้น',
            meeting_room_end_time: 'ระบุเวลาสิ้นสุด',
            meeting_room_name: 'ระบุชื่อเรื่อง',
        }
    })

    const uploadFileBookingMeeting = async (file: File): Promise<number | null> => {
        const formData = new FormData();
        formData.append('files', file);
        return await BookingMeetingRoomFront.uploadMultiFile(formData).then((res) => {
            if (res.status < 300) {
                const file: any[] = res.data || [];
                const id_meeting_room_file = file[0]?.id_meeting_room_file || null
                return id_meeting_room_file
            } else {
                return null
            }
        }).catch((err) => {
            console.log(err, 'err')
        })
    }
    const uploadMultiFilePromise = async (files: File[]): Promise<{ file: any }[]> => {
        dispatch(setLoading());
        const form_data = new FormData();
        files.forEach((file) => {
            form_data.append('files', file);
        })
        return await BookingMeetingRoomFront.uploadMultiFile(form_data).then((res) => {
            if (res.status < 300) {
                return res?.data?.map((list: any) => {
                    return {
                        file: list
                    }
                }) || []
            } else {
                return []
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading())
        })
    }

    const handleSubmit = async (is_draft?: boolean, next?: boolean, status?: string, callback?: () => void) => {
        const body = await generateBody(is_draft, status);
        if (!check_error_field.is_valid) {
            return set_error_message(check_error_field.errors);
        }
        dispatch(setLoading());
        if (id) {
            await BookingMeetingRoomApi.updateBookingMeetingRoom(+id, body).then((res) => {
                if (res.status < 300) {
                    if (next) {
                        set_step((prev) => prev + 1);
                    }
                    alertSuccess("บันทึกข้อมูล", "บันทึกข้อมูล เรียบร้อย");
                    handleGetDetail(+id);
                    callback?.();
                }
            }).catch((err) => {
                console.log(err);
                const data_detail = err?.response?.data;
                const details: any[] = data_detail?.details || [];
                const htmlText = details
                    .map((item, idx) => {
                        return `
    <div style="text-align:left; margin-bottom:12px;">
        <b>รายการ ${idx + 1}</b><br>
        ${item.day_name ? `• วัน: ${item.day_name}<br>` : ""}
        • วันที่: ${moment(item.room_meeting_start_date).format("DD/MM/YYYY")} - ${moment(item.room_meeting_end_date).format("DD/MM/YYYY")}<br>
        • เวลา: ${item.room_meeting_time}
    </div>
    `;
                    })
                    .join("");
                alertError(`เกิดข้อผิดพลาด ${data_detail?.message}`, htmlText, undefined, undefined, true)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await BookingMeetingRoomApi.createBookingMeetingRoom(body).then((res) => {
                if (res.status < 300) {
                    const id_meeting_room = res.data?.data?.id_meeting_room;
                    alertSuccess("บันทึกข้อมูล", "บันทึกข้อมูล เรียบร้อย")
                    if (id_meeting_room) {
                        if (is_personal) {
                            window.location.replace(routeName.cms.BookingRoomUpdate.replace(":id", id_meeting_room));
                        } else {
                            window.location.replace(routeName.public.classroom_meeting_booking_detail.replace(":id", id_meeting_room));
                        }
                    } else {
                        if (is_personal) {
                            navigate(routeName.cms.BookingRoom);
                        } else {
                            navigate(routeName.public.classroom_meeting_booking);
                        }
                    }
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    const handleConfirmBookingMeetingRoom = () => {
        alertActive("ส่งคำร้องขอจองห้องเรียน/จองห้องประชุม", "ท่านต้องการ ส่งคำร้องขอจองห้องเรียน/จองห้องประชุม ใช่หรือไม่", undefined, undefined, async () => {
            await handleSubmit(false, undefined, BOOKING_MEETING_ROOM.WAITING_TO_CONSIDER, () => {
                if (is_personal) {
                    navigate(routeName.cms.BookingRoom);
                } else {
                    navigate(routeName.public.classroom_meeting_booking);
                }
            });
        })
    }

    const handleDownloadFile = async (id_meeting_room_file: number, file_name: string) => {
        dispatch(setLoading());
        await BookingMeetingRoomFront.downloadFile(id_meeting_room_file).then((res) => {
            if (res.status < 300) {
                const response = res.data;
                const content_type = res.headers['Content-Type'] || ""
                const blob_file = new Blob([response], {
                    type: content_type.toString() || ""
                });
                saveAs(blob_file, file_name);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    const [show_modal_approve, set_show_modal_approve] = useState<boolean>(false);
    const [is_waiting, set_is_waiting] = useState<boolean>(false);
    const [meeting_room_approve_remark, set_meeting_room_approve_remark] = useState<string>("");

    const handleCloseModalApproveAndReject = () => {
        set_meeting_room_approve_remark("");
        set_show_modal_approve(false);
        set_is_waiting(false);
    }

    const handleChangeStatusBookingMeetingRoom = async (id_meeting_room: number, status: string, text: string, text_detail: string) => {
        alertActive(text, text_detail, undefined, undefined, async () => {
            dispatch(setLoading());
            await BookingMeetingRoomApproveApi.approve(id_meeting_room, ({
                meeting_room_approve_remark: "",
                meeting_room_approve_type: status
            })).then((res) => {
                if (res.status < 300) {
                    navigate(routeName.cms.BookingRoomRequestMangement);
                    alertSuccess("บันทึกข้อมูล", "บันทึกข้อมูล ไม่สำเร็จ");
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleWaiting = () => {
        set_is_waiting(true);
    }
    const handleSubmitWaiting = async (id_meeting_room: number, callback?: () => void) => {
        await BookingMeetingRoomApproveApi.approve(id_meeting_room, {
            meeting_room_approve_remark: meeting_room_approve_remark,
            meeting_room_approve_type: BOOKING_MEETING_APPROVE.WAITING
        }).then((res) => {
            if (res.status < 300) {
                handleCloseModalApproveAndReject();
                alertSuccess("ส่งทบทวน", "ส่งทบทวน เรียบร้อยแล้ว");
                callback?.();
            }
        }).catch((err) => {
            console.log(err);
            alertError("ส่งทบทวน ไม่สำเร็จ", err?.response?.data?.message || "")
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleAcceptAndReject = async (id_meeting_room: number, reject?: boolean, submit_reject?: boolean, callback?: () => void) => {
        if (reject) {
            if (submit_reject) {
                dispatch(setLoading());
                await BookingMeetingRoomApproveApi.approve(id_meeting_room, {
                    meeting_room_approve_remark: meeting_room_approve_remark,
                    meeting_room_approve_type: BOOKING_MEETING_APPROVE.REJECT
                }).then((res) => {
                    if (res.status < 300) {
                        handleCloseModalApproveAndReject();
                        alertSuccess("ไม่อนุมัติคำร้องขอจอง", "ไม่อนุมัติคำร้องขอจอง เรียบร้อยแล้ว");
                        callback?.();
                    }
                }).catch((err) => {
                    console.log(err);
                    alertError("ไม่อนุมัติคำร้องขอจอง ไม่สำเร็จ", err?.response?.data?.message || "")
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            } else {
                set_show_modal_approve(true);
            }
        } else {
            alertActive(is_outside ? "แจ้งให้ดำเนินการชำระเงิน" : "อนุมัติคำร้องขอจอง", is_outside ? "ท่านต้องการแจ้งให้ดำเนินการชำระเงิน ใช่หรือไม่" : "ท่านต้องการอนุมัติคำร้องขอจอง ใช่หรือไม่", undefined, undefined, async () => {
                dispatch(setLoading());
                await BookingMeetingRoomApproveApi.approve(id_meeting_room, {
                    meeting_room_approve_remark: "",
                    meeting_room_approve_type: BOOKING_MEETING_APPROVE.APPROVE
                }).then((res) => {
                    if (res.status < 300) {
                        alertSuccess(
                            is_outside ?
                                "แจ้งให้ดำเนินการชำระเงิน" : "อนุมัติคำร้องขอจอง",
                            is_outside ? "แจ้งให้ดำเนินการชำระเงิน เรียบร้อยแล้ว" : "อนุมัติคำร้องขอจอง เรียบร้อยแล้ว"
                        );
                        callback?.();
                    }
                }).catch((err) => {
                    console.log(err);
                    alertError("อนุมัติคำร้องขอจอง ไม่สำเร็จ", err?.response?.data?.message || "")
                }).finally(() => {
                    dispatch(unsetLoading());
                })
            })
        }
    }
    const handleGetPayment = async () => {
        dispatch(setLoading());
        await PaymentChannelApi.getPaymentChannelByType({ type_channel_payment: "PAYMENT_MEETING_ROOM" }).then((res) => {
            if (res.status < 300) {
                const paymentChannel = res.data?.data?.paymentChannel;
                set_payment_channel_data(paymentChannel);
                if (paymentChannel?.bank_name_th) {
                    const data_value = bankListArray?.find((x) => x.name === paymentChannel?.bank_name_th) || null
                    set_select_bank(data_value);
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleGetDetail = async (id_meeting_room: number) => {
        dispatch(setLoading());
        await BookingMeetingRoomApi.findOneBookingMeetingRoom(id_meeting_room).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.meeting_room || null;
                const room_meeting_master = response?.room_meeting_master || null;
                const files_other: any[] = response?.files_other || [];
                if (response?.id_room_meeting) {
                    setSelectedId(response?.id_room_meeting);
                }
                if (files_other?.length > 0) {
                    setFormState((prev) => ({ ...prev, file: files_other[0] }));
                }
                if (room_meeting_master?.room_meeting_type) {
                    set_room_meeting_type({ label: room_meeting_master?.room_meeting_type, value: room_meeting_master?.room_meeting_type })
                }
                set_remark(response?.booking_approve?.meeting_room_approve_remark || "");
                set_is_outside(!!response?.member);
                setFormState((prev) => ({
                    meeting_room_desc: response?.meeting_room_desc || "",
                    meeting_room_end_date: response?.meeting_room_end_date || "",
                    meeting_room_end_time: response?.meeting_room_end_time || "",
                    meeting_room_name: response?.meeting_room_name || "",
                    meeting_room_start_date: response?.meeting_room_start_date || "",
                    meeting_room_start_time: response?.meeting_room_start_time || "",
                    meeting_room_status: response?.meeting_room_status || "",
                    meeting_room_type: response?.meeting_room_type || "",
                    id_meeting_file_other: null,
                    id_meeting_type: null,
                    id_room_meeting: null,
                    id_content: null,
                    file: prev?.file
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    useEffect(() => {
        handleGetPayment();
    }, [])

    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id)
        }
    }, [id])

    return {
        pathname,
        set_room_meeting_type,
        room_meeting_type,
        step,
        set_step,
        setSelectedId,
        selectedId,
        formState,
        setFormState,
        handleSubmit,
        error_message,
        clearErrorMessage,
        check_error_field,
        handleDownloadFile,
        handleConfirmBookingMeetingRoom,
        show_modal_approve,
        handleCloseModalApproveAndReject,
        handleAcceptAndReject,
        meeting_room_approve_remark,
        set_meeting_room_approve_remark,
        payment_channel_data,
        select_bank,
        payment_file,
        handleChangeStatusBookingMeetingRoom,
        is_outside,
        handleWaiting,
        is_waiting,
        handleSubmitWaiting,
        remark,
        uploadMultiFilePromise
    }

}